import { render, staticRenderFns } from "./ChildSupportStandalone.vue?vue&type=template&id=c8370e44"
import script from "./ChildSupportStandalone.vue?vue&type=script&lang=js"
export * from "./ChildSupportStandalone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports